var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRadioShows = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Radio-Antenna-1--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Radio Antenna 1 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m20.75 8 -0.07 0L1.38 0.08a1 1 0 0 0 -0.76 1.84l13.63 5.6a0.25 0.25 0 0 1 0.16 0.28 0.26 0.26 0 0 1 -0.25 0.2H3.5A3.5 3.5 0 0 0 0 11.5v9A3.5 3.5 0 0 0 3.5 24h17a3.5 3.5 0 0 0 3.5 -3.5v-9A3.5 3.5 0 0 0 20.75 8Zm-0.25 4.48a2 2 0 1 1 -2 -2 2 2 0 0 1 2 2.01Zm0 4a0.75 0.75 0 0 1 0 1.5h-4a0.75 0.75 0 0 1 0 -1.5Zm-4 3h4a0.75 0.75 0 0 1 0 1.5h-4a0.75 0.75 0 0 1 0 -1.5Zm-3 -3.5A5.5 5.5 0 1 1 8 10.5a5.49 5.49 0 0 1 5.49 5.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.94 13a0.76 0.76 0 0 0 0.75 0.75h0.61a0.75 0.75 0 0 0 0 -1.5h-0.61a0.76 0.76 0 0 0 -0.75 0.75Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.87 15.42a0.75 0.75 0 0 0 0.38 0.1 0.76 0.76 0 0 0 0.65 -0.38l0.3 -0.52a0.75 0.75 0 0 0 -0.27 -1 0.76 0.76 0 0 0 -1 0.27l-0.3 0.53a0.75 0.75 0 0 0 0.24 1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.9 16.86a0.75 0.75 0 0 0 -1.3 0.76l0.31 0.52a0.76 0.76 0 0 0 0.65 0.38 0.74 0.74 0 0 0 0.37 -0.1 0.76 0.76 0 0 0 0.28 -1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.31 18.25H7.7a0.75 0.75 0 1 0 0 1.5h0.61a0.75 0.75 0 1 0 0 -1.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.13 16.58a0.75 0.75 0 0 0 -1 0.28l-0.3 0.52a0.75 0.75 0 0 0 1.3 0.76l0.3 -0.53a0.75 0.75 0 0 0 -0.3 -1.03Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1 15.14a0.76 0.76 0 0 0 1 0.27 0.76 0.76 0 0 0 0.27 -1l-0.31 -0.52a0.74 0.74 0 0 0 -1 -0.28 0.76 0.76 0 0 0 -0.28 1Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRadioShows);
export default ForwardRef;